<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        role="img"
    >
        <title>User Icon</title>
        <svg width="40px" height="40px">
            <circle
                cx="20"
                cy="20"
                r="19.5"
            />
        </svg>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            x="8"
            y="7"
        >
            <path
                d="M12 12.007C14.9688 12.007 17.4286 9.58963 17.4286 6.57847C17.4286 3.60972 14.9688 1.1499 12 1.1499C8.98884 1.1499 6.57143 3.60972 6.57143 6.57847C6.57143 9.58963 8.98884 12.007 12 12.007ZM15.7746 13.3642H15.0536C14.1205 13.8307 13.1027 14.0428 12 14.0428C10.8973 14.0428 9.83705 13.8307 8.90402 13.3642H8.18304C5.04464 13.3642 1.5 15.9512 1.5 19.0896V20.8285C1.5 21.9736 2.39062 22.8642 3.53571 22.8642H20.4643C21.567 22.8642 22.5 21.9736 22.5 20.8285V19.0896C22.5 15.9512 18.9129 13.3642 15.7746 13.3642Z"
            />
        </svg>
    </svg>
</template>
